import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100",
    style: { "z-index": "9999" }
};
const _hoisted_2 = {
    key: 1,
    class: "col bg-white p-4"
};
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-xxl-7 col-xxxl-6" };
const _hoisted_5 = { class: "col-xxl-5 col-xxxl-6" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-lg-12" };
const _hoisted_8 = { class: "row row-cols-1 row-cols-md-2 row-cols-xl-4 bg-white mb-8" };
const _hoisted_9 = {
    key: 0,
    class: "col mb-6"
};
const _hoisted_10 = { class: "card radius-10 border-start border-0 border-3 border-info" };
const _hoisted_11 = { class: "card-body" };
const _hoisted_12 = { class: "d-flex align-items-center" };
const _hoisted_13 = { class: "mb-0 text-secondary" };
const _hoisted_14 = { class: "my-1 text-info" };
const _hoisted_15 = {
    key: 1,
    class: "col"
};
const _hoisted_16 = { class: "card radius-10 border-start border-0 border-3 border-danger" };
const _hoisted_17 = { class: "card-body" };
const _hoisted_18 = { class: "d-flex align-items-center" };
const _hoisted_19 = { class: "mb-0 text-secondary" };
const _hoisted_20 = { class: "my-1 text-danger" };
const _hoisted_21 = {
    key: 2,
    class: "col"
};
const _hoisted_22 = { class: "card radius-10 border-start border-0 border-3 border-success" };
const _hoisted_23 = { class: "card-body" };
const _hoisted_24 = { class: "d-flex align-items-center" };
const _hoisted_25 = { class: "mb-0 text-secondary" };
const _hoisted_26 = { class: "my-1 text-primary" };
const _hoisted_27 = {
    key: 3,
    class: "col"
};
const _hoisted_28 = { class: "card radius-10 border-start border-0 border-3 border-warning" };
const _hoisted_29 = { class: "card-body" };
const _hoisted_30 = { class: "d-flex align-items-center" };
const _hoisted_31 = { class: "mb-0 text-warning" };
const _hoisted_32 = { class: "my-1 text-warning" };
const _hoisted_33 = {
    key: 0,
    class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
};
const _hoisted_34 = { class: "title" };
const _hoisted_35 = { class: "fw-medium text-muted fs-13 d-block mb-5 text-uppercase" };
const _hoisted_36 = { class: "card-title fw-black mb-0" };
const _hoisted_37 = { class: "card-select mt-10 mt-sm-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5" };
const _hoisted_38 = { class: "fw-medium text-muted me-8" };
const _hoisted_39 = ["value"];
const _hoisted_40 = {
    key: 1,
    class: "chart bg-white mt-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_WhatHappening = _resolveComponent("WhatHappening");
    const _component_VabeneNombreCommandeProductDate = _resolveComponent("VabeneNombreCommandeProductDate");
    const _component_apexchart = _resolveComponent("apexchart");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_LoaderComponent)
            ]))
            : _createCommentVNode("", true),
        (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_WhatHappening, {
                            orderAmount: String(_ctx.getCardValue(0) || '0'),
                            id: "whatHappening"
                        }, null, 8, ["orderAmount"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_VabeneNombreCommandeProductDate, {
                                    id: "nombreCommandeProductDate",
                                    restaurantId: _ctx.restaurantId ?? 'all',
                                    totalAmount: _ctx.totalAmount,
                                    onFiltersChanged: _ctx.handleFiltersChanged
                                }, null, 8, ["restaurantId", "totalAmount", "onFiltersChanged"])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    (_ctx.periodiqueReportCard)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.salesThisWeekLabel')), 1),
                                            _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.getCardValue(0)) + " CHF", 1)
                                        ]),
                                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto" }, [
                                            _createElementVNode("i", { class: "fa fa-shopping-cart" })
                                        ], -1))
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.periodiqueReportCard)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('dashboard.previousWeek')), 1),
                                            _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.getCardValue(1)), 1)
                                        ]),
                                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "widgets-icons-2 rounded-circle bg-gradient-bloody text-white ms-auto" }, [
                                            _createElementVNode("i", { class: "fa fa-dollar" })
                                        ], -1))
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.periodiqueReportCard)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('dashboard.thisMonth')), 1),
                                            _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.getCardValue(2)), 1)
                                        ]),
                                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "widgets-icons-2 rounded-circle bg-gradient-ohhappiness text-white ms-auto" }, [
                                            _createElementVNode("i", { class: "fa fa-bar-chart" })
                                        ], -1))
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.periodiqueReportCard)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('dashboard.thisYear')), 1),
                                            _createElementVNode("h4", _hoisted_32, _toDisplayString(_ctx.getCardValue(3)) + " CHF", 1)
                                        ]),
                                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "widgets-icons-2 rounded-circle bg-gradient-blooker text-white ms-auto" }, [
                                            _createElementVNode("i", { class: "fa fa-users" })
                                        ], -1))
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.reportVente && _ctx.reportVente.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.getTitleForPeriod), 1),
                            _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.getSelectedPeriodTotal) + " CHF ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('dashboard.select')), 1),
                            _withDirectives(_createElementVNode("select", {
                                class: "form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedPeriod) = $event))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportVente, (option, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: index,
                                        value: index,
                                        class: "fw-medium"
                                    }, _toDisplayString(option.name), 9, _hoisted_39));
                                }), 128))
                            ], 512), [
                                [_vModelSelect, _ctx.selectedPeriod]
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.reportVente && _ctx.reportVente.length > 0 && _ctx.formattedSeries.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        (_openBlock(), _createBlock(_component_apexchart, {
                            key: _ctx.chartKey,
                            type: "line",
                            height: "374",
                            id: "vabeneWeeklySalesChart",
                            options: _ctx.weeklySalesChart,
                            series: _ctx.formattedSeries
                        }, null, 8, ["options", "series"]))
                    ]))
                    : _createCommentVNode("", true)
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
